
import styled from 'styled-components';
import { MagstimColor } from 'common';

export const GroupedTableWrapper = styled.div`
.table-wrapper {
    .table-scroll {
        table tbody {
            tr.group-header {
                background: ${MagstimColor.MagstimLightGrey};

                td {
                    color: ${MagstimColor.MagstimDarkNavy};
                    font-weight: bold;
                    text-align: left;
                }

                td.dummy-cell {
                    color: ${MagstimColor.MagstimLightGrey};
                }
            }
        }
    }
}

`;